var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5C28 19.1653 22.7145 27.9749 18.7579 34.3566C16.9211 37.3188 16.0028 38.8 14.5 38.8C12.9972 38.8 12.0789 37.3188 10.2421 34.3566C6.2856 27.9749 1 19.1653 1 14.5C1 7.04417 7.04417 1 14.5 1C21.9558 1 28 7.04417 28 14.5Z",
    fill: "white",
    stroke: "#5F73E3",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.416 24.623H20.2997V26.0358C20.2997 26.2958 20.0888 26.5068 19.8288 26.5068H18.8869C18.627 26.5068 18.416 26.2958 18.416 26.0358V24.623Z",
    stroke: "#5F73E3",
    strokeWidth: 1.01573
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05566 24.623H9.93939V26.0358C9.93939 26.2958 9.72841 26.5068 9.46846 26.5068H8.5266C8.26664 26.5068 8.05566 26.2958 8.05566 26.0358V24.623Z",
    stroke: "#5F73E3",
    strokeWidth: 1.01573
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93939 19.9141H18.4162C19.4564 19.9141 20.2999 20.7575 20.2999 21.7978V24.1524C20.2999 24.4124 20.0889 24.6233 19.829 24.6233H8.5266C8.26664 24.6233 8.05566 24.4124 8.05566 24.1524V21.7978C8.05566 20.7575 8.8991 19.9141 9.93939 19.9141Z",
    stroke: "#5F73E3",
    strokeWidth: 1.01573
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4162 21.7979C18.6762 21.7979 18.8872 22.0088 18.8872 22.2688C18.8872 22.5287 18.6762 22.7397 18.4162 22.7397C18.1563 22.7397 17.9453 22.5287 17.9453 22.2688C17.9453 22.0088 18.1563 21.7979 18.4162 21.7979Z",
    fill: "#3C3C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9387 21.7979C10.1987 21.7979 10.4096 22.0088 10.4096 22.2688C10.4096 22.5287 10.1987 22.7397 9.9387 22.7397C9.67875 22.7397 9.46777 22.5287 9.46777 22.2688C9.46777 22.0088 9.67875 21.7979 9.9387 21.7979Z",
    fill: "#3C3C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7362 16.1465H17.6184C17.8148 16.1465 17.9904 16.2685 18.0592 16.4521L19.3576 19.9139H8.99707L10.2954 16.4521C10.3642 16.2685 10.5398 16.1465 10.7362 16.1465Z",
    stroke: "#5F73E3",
    strokeWidth: 1.01573
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58496 18.501H8.99776V19.4428H7.58496V18.501Z",
    fill: "#3C3C3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 18.501H20.7712V19.4428H19.3584V18.501Z",
    fill: "#3C3C3C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3525 22.2676H17.0037",
    stroke: "#5F73E3",
    strokeWidth: 1.01573
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/LocationPin.2ed1c56f6e69057fc18907a88201668f.svg";
export { ForwardRef as ReactComponent };